export default "__VITE_ASSET__531d477f__"